import { strings } from "utils/localizedStrings";

export class UserManagementConstants {
  static userTypeMapping(value: number, localStrings: typeof strings) {
    switch (value) {
      case 0:
        return "Normal";
      case 3:
        return localStrings.UserManagement.UserType.Agency;
      case 4:
        return localStrings.UserManagement.UserType.Store;
      case 5:
        return localStrings.UserManagement.UserType.Employee;
      default:
        return localStrings.GlobalLabels.NoInfo;
    }
  }
}
